import styles from "./styles.scss";
import { Body } from "../typography";
import ListItem from "../list-item";
import Avatar from "../avatar";
import { useContext } from "preact/hooks";
import {
  CurrentUserContext,
  MessagesContext,
  OrganizationContext,
  RoomsContext
} from "../../contexts";
import { getProfile } from "../../selectors";
import Icon from "../Icon/Icon";
import { parseISO, format, isToday, isYesterday } from "date-fns";
import {NavigationContext} from "../../contexts/NavigationContext";
import Margin from "../Margin/Margin";

const formatTimestamp = (timestamp) => {
  const date = parseISO(timestamp);
  if (isToday(date))
    return format(date, "HH:mm");
  if (isYesterday(date))
    return "Ontem";
  else return format(date, "dd/MM/yyyy");
};

export default function ChatList() {
  const currentUser = useContext(CurrentUserContext);
  const rooms = useContext(RoomsContext);
  const messages = useContext(MessagesContext);
  const organization = useContext(OrganizationContext);
  const navigation = useContext(NavigationContext);

  const onRequestChat = (roomId) => {
    navigation.navigate({ path: "/chat", params: { roomId } });
  };

  const computedRooms = rooms.map((room) => ({
    ...room,
    latestMessage: messages.slice().reverse().find(message => message.roomId === room.id),
    totalUnreadMessages: messages.filter(message => message.roomId === room.id && message.readBy !== 2 && message.senderInternalId !== currentUser.internalId).length,
    otherUser: getProfile(organization, room.usersInternalIds.find(id => id !== currentUser.internalId)),
    type: room.type,
    channelName: room.channelName,
  })).filter(({ otherUser }) => otherUser).sort((a, b) => {
    if (a.latestMessage.sentAt < b.latestMessage.sentAt)
      return 1;
    if (a.latestMessage.sentAt > b.latestMessage.sentAt)
      return -1;
    return 0;
  })
  .map(({type, channelName, otherUser, ...computedRoom}) => ({
    ...computedRoom,
    name: type === 'channel' ? channelName : otherUser.name,
    avatarUrl: type === 'channel' ? '' : otherUser.avatar_url,
  }))
  .map(({latestMessage, ...computedRoom}) => ({
    ...computedRoom,
    latestMessage,
    latestMessageSender: getProfile(organization, latestMessage.senderInternalId),
  }))
  .map(({latestMessageSender, latestMessage, type, ...computedRoom}) => ({
    ...computedRoom,
    latestMessage,
    latestMessageSender,
  }));

  const renderReadIcon = (latestMessage, latestMessageSender) => {
    if (latestMessageSender.internal_id !== currentUser.internalId)
      return null;
    if (latestMessage.readBy !== 2)
      return <Icon name="check" color="#9E9E9E" size={14} className={styles.timestampIcon} />;
    return <Icon name="check_all" color="#00AFFF" size={14} className={styles.timestampIcon} />;
  };

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.listContainer}>
          {
            computedRooms.map(
            ({ latestMessageSender, latestMessage, totalUnreadMessages, id, name, avatarUrl }) => (
              <ListItem
                key={id}
                left={<Avatar src={avatarUrl} />}
                title={<Body size="body1">{name}</Body>}
                subtitle={
                  <Margin top={4}>
                    <Body className={styles.latestMessageContent} size="body2">
                      {renderReadIcon(latestMessage, latestMessageSender)} {latestMessage.content}
                    </Body>
                  </Margin>
                }
                right={<div className={styles.right}>
                  <div className={styles.timestamp}>{formatTimestamp(latestMessage.sentAt)}</div>
                  {totalUnreadMessages > 0 && <div className={styles.badge}>{totalUnreadMessages}</div>}
                </div>}
                onClick={() => onRequestChat(id)}
                hoverFeedback
              />
            )
          )}
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/chat-list/index.js